// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"473":"87f8521e","796":"03e52f57"}[chunkId] + ".chunk.js";
};